import { useEffect } from "react";

// Custom hook to handle table responsiveness
export const useTableResponsive = (tableData) => {
  useEffect(() => {
    const adjustDataKey = (tableElement) => {
      if (!tableElement) return;

      const tds = tableElement.querySelectorAll("td");
      if (window.innerWidth <= 768) {
        tds.forEach((td) => {
          const dataKey = td.getAttribute("data-key");
          if (!dataKey) return;
          const baseHeight = 34;
          const lengthFactor = 2;
          const calculatedMinHeight =
            baseHeight + dataKey.length * lengthFactor;
          td.style.minHeight = `${calculatedMinHeight}px`;
        });
      }
    };

    const tableElements = document.querySelectorAll(".custom-table");
    tableElements.forEach((table) => adjustDataKey(table));

    const handleResize = () => {
      tableElements.forEach((table) => adjustDataKey(table));
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [tableData]);
};
